import { useEffect } from 'react';

// New-UI editor polish that CSS alone can't do (docs/ui_redesign/13-invoice-editor-cockpit.md). Display only.
// - A read-only value too long for its field (a file name, a long status, a vendor on a laptop) gets its full text as a
//   tooltip. A field's own title (Classic sets some, e.g. the total mismatch) is never replaced.
// - A line table with columns hidden to the right or left shows a fade on that side, so it reads as scrollable.
const OWN = 'data-apw2-title';

export function fullValueTitles(root) {
	if (!root) return;
	root.querySelectorAll('.apw2-ed-fields .row-form :is(input[readonly], input:disabled, select:disabled)').forEach(el => {
		const text = el.tagName === 'SELECT' ? (el.selectedOptions[0] ? el.selectedOptions[0].textContent.trim() : '') : String(el.value || '').trim();
		const cut = el.tagName === 'SELECT' || el.scrollWidth > el.clientWidth + 1; // a select's text can't be measured; it always gets one
		const ours = el.hasAttribute(OWN);
		if (el.title && !ours) return;
		if (cut && text) { el.title = text; el.setAttribute(OWN, ''); } else if (ours) { el.removeAttribute('title'); el.removeAttribute(OWN); }
	});
}

export function scrollHints(container) {
	const paper = container && container.parentElement;
	if (!paper) return;
	const max = container.scrollWidth - container.clientWidth;
	paper.style.setProperty('--apw2-fade-top', container.offsetTop + 'px'); // the fade covers the table, not its toolbar
	paper.classList.toggle('apw2-more-right', max > 2 && container.scrollLeft < max - 2);
	paper.classList.toggle('apw2-more-left', max > 2 && container.scrollLeft > 2);
}

export function EditorPolish({ rootRef }) {
	useEffect(() => {
		const root = rootRef.current;
		if (!root) return undefined;
		const watched = new WeakSet();
		let frame = 0;
		const onScroll = e => scrollHints(e.currentTarget);
		const run = () => {
			frame = 0;
			fullValueTitles(root);
			root.querySelectorAll('.MuiPaper-outlined > .MuiTableContainer-root').forEach(c => {
				if (!watched.has(c)) { watched.add(c); c.addEventListener('scroll', onScroll, { passive: true }); }
				scrollHints(c);
			});
		};
		const schedule = () => { if (!frame) frame = requestAnimationFrame(run); };
		run();
		const observer = new MutationObserver(schedule);
		observer.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'style'] });
		root.addEventListener('input', schedule);
		window.addEventListener('resize', schedule);
		return () => {
			observer.disconnect();
			root.removeEventListener('input', schedule);
			window.removeEventListener('resize', schedule);
			if (frame) cancelAnimationFrame(frame);
		};
	}, [rootRef]);
	return null;
}
